import { OrdningsPrinsipp } from './../../../models';
import RequestService from '../requestService';
import { client } from '../../client';


export default class OrdningsPrinsippService extends RequestService<OrdningsPrinsipp, 'ordningsPrinsipp'> {
    constructor(serviceName: 'ordningsPrinsipp') {
        super(serviceName);
        this.idKey = 'uniqueId';
    }
    validateFraDato = async (value: OrdningsPrinsipp) => client.post<boolean>(`${this.serviceName}/ValidateFraDato`, value);
    validateTilDato = async (value: OrdningsPrinsipp) => client.post<boolean>(`${this.serviceName}/ValidateTilDato`, value);
    override update(item: OrdningsPrinsipp): Promise<OrdningsPrinsipp> {
        return super.update(item);
    }
}